class DrilldownViewListItemVM {
    tabName: KnockoutObservable<string>;
    icon: string;
    iconClass: string;
    drilldownIndex: number;
    template: Function;
    drilldownFilters: KnockoutObservableArray<Filter>;
    filters: KnockoutObservableArray<Filter>;
    hint: KnockoutComputed<string>;
    fullHint: KnockoutComputed<string>;
    tabTitle: KnockoutComputed<string>;
    widget: KnockoutObservable<IWidget>;
    title: string;
    content: JQuery<HTMLElement>;

    constructor(text: string, drilldownIndex: number, widget: IWidget, template: Function) {
        let self = this;

        this.tabName = ko.observable(text);
        this.icon = "arrow_right";
        this.drilldownIndex = drilldownIndex;
        this.template = function () {
            self.content = $("<div></div>");
            self.content.append(template());
            return self.content;
        };
        this.filters = ko.observableArray([]);
        this.drilldownFilters = ko.observableArray([]);
        this.widget = ko.observable(widget);
        this.title = drilldownIndex + "";

        this.hint = ko.computed(function () {
            let hint = "";
            if (self.drilldownFilters().length) {
                let first = true;
                let filters: Array<Filter> = self.drilldownFilters();
                for (let filter of filters) {
                    if (filter.showForDrilldown()) {
                        if (!first) {
                            hint += ", ";
                        }
                        else {
                            first = false;
                        }
                        //hint += filter.filter.filterName() + "=" + filter.filter.startDisplayCondition();
                        hint += filter.startDisplayCondition();
                    }
                }
            }
            return hint;
        });

        this.fullHint = ko.computed(function () {
            let hint = "";
            if (self.drilldownFilters().length) {
                let first = true;
                let filters: Array<Filter> = self.drilldownFilters();
                for (let filter of filters) {
                    if (filter.showForDrilldown()) {
                        if (!first) {
                            hint += "\n";
                        }
                        else {
                            first = false;
                        }
                        hint += filter.filterName() + ": " + filter.startDisplayCondition();
                        //hint += filter.filter.startDisplayCondition();
                    }
                }
            }
            hint = replaceBasicHtmlContent(hint);
            return hint;
        });

        this.tabTitle = ko.computed(function () {
            let title = "";
            let filtersText = self.hint();
            if (filtersText !== "") {
                filtersText = replaceBasicHtmlContent(filtersText);
                title += " (";
                if (filtersText.length > 30) {
                    title += filtersText.substring(0, 30) + "..."
                }
                else {
                    title += filtersText;
                }
                title += ")";
            }
            return title;
        });
    }

    getWidget<TWidget>(): TWidget {
        return this.widget() as TWidget;
    }
}